import { mapGetters } from 'vuex'
export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['realMobile']),
    labelPosition() {
      if(!this.realMobile){
        return 'right'
      }else {
        return 'top'
      }
    }
  },
}
